<template>
  <router-view :key="$route.fullPath"/>
</template>

<script>

import APIClient from "@/service/APIClient";

const api = new APIClient();

export default {
  name: "App",
  computed: {},
  methods: {
  },
  async created() {
  }
}
</script>

